import { ETheme } from "@/common/entity/Enum";
import { renderColorByTheme } from "@/common/function/FunctionTheme";
import styled from "styled-components";

export const FloorPlanBaseWrapper = styled.div<{ $theme?: string }>`
  margin: 8px;
  .floor-box-status-container {
    background: ${props => props.$theme === ETheme.Dark ? "#0D1D2C" : "var(--bg-darkcolor, #e7f0f8)"} ;
    border-radius: 0px 0px 2px 2px;
    flex-shrink: 0;
    width: 100%;
    height: 32px;
    position: relative;
    overflow: auto;
    margin-top: 5px;
  }

  .inner {
    border: 2px rgba(0, 0, 0, 0.1) dashed;
  }

  .floor-box-status-header {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: flex-start;
    justify-content: flex-start;
    position: absolute;
    left: 5px;
    top: 8px;
  }

  .frame-427323071 {
    display: flex;
    flex-direction: row;
    gap: 6px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
  }

  .rectangle-24312 {
    flex-shrink: 0;
    width: 6px;
    height: 16px;
    position: relative;
  }

  .available {
    color: ${props => renderColorByTheme(props.$theme)};
    text-align: left;
    font: var(
      --textstyleoutlook-bodysmall,
      400 12px/16px "Segoe UI",
      sans-serif
    );
    position: relative;
  }

  .frame-4273230762 {
    display: flex;
    flex-direction: row;
    gap: 6px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
  }

  .rectangle-243122 {
    flex-shrink: 0;
    width: 6px;
    height: 16px;
    position: relative;
  }

  .selected {
    color: ${props => renderColorByTheme(props.$theme)};
    text-align: left;
    font: var(
      --textstyleoutlook-bodysmall,
      400 12px/16px "Segoe UI",
      sans-serif
    );
    position: relative;
  }

  .frame-427323077 {
    display: flex;
    flex-direction: row;
    gap: 6px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
  }

  .rectangle-243123 {
    flex-shrink: 0;
    width: 6px;
    height: 16px;
    position: relative;
  }

  .own {
    color: #000000;
    text-align: left;
    font: var(
      --textstyleoutlook-bodysmall,
      400 12px/16px "Segoe UI",
      sans-serif
    );
    position: relative;
  }

  .frame-427323078 {
    display: flex;
    flex-direction: row;
    gap: 6px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
  }

  .rectangle-243124 {
    flex-shrink: 0;
    width: 6px;
    height: 16px;
    position: relative;
  }

  .booked {
    color: #000000;
    text-align: left;
    font: var(
      --textstyleoutlook-bodysmall,
      400 12px/16px "Segoe UI",
      sans-serif
    );
    position: relative;
  }

  .frame-427323079 {
    display: flex;
    flex-direction: row;
    gap: 6px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
  }

  .rectangle-243125 {
    flex-shrink: 0;
    width: 6px;
    height: 16px;
    position: relative;
  }

  .closed {
    color: ${props => renderColorByTheme(props.$theme)};
    text-align: left;
    font: var(
      --textstyleoutlook-bodysmall,
      400 12px/16px "Segoe UI",
      sans-serif
    );
    position: relative;
  }

  .colluege-detail {
    display: flex;
    align-items: center;
    font-size: 12px;
  }

  .icon-box {
    text-align: center;
    padding: 5px 5px 0px 5px;
  }

  .rounded-avatar {
    border-radius: 50%;
  }

  .filter-find-colleague * {
    box-sizing: border-box;
  }

  .filter-find-colleague {
    background: rgba(16, 110, 190, 0.05);
    padding: 11px 8px 11px 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    justify-content: flex-start;
    flex-shrink: 0;
    width: 330px;
    position: relative;
  }

  .frame-427323319 {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
  }

  .chevron {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    position: relative;
    overflow: visible;
  }

  .frame-427325643 {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
  }

  .ellipse-5 {
    background: linear-gradient(to left, #d9d9d9, #d9d9d9);
    border-radius: 50%;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    position: relative;
  }

  .name-colleague-cls {
    color: var(--primary-primary, #106ebe);
    text-align: center;
    font: var(
      --text-style-outlook-h-3,
      600 12px/16px "SegoeUi-Semibold",
      sans-serif
    );
    position: relative;
  }

  .text-location-3321 {
    color: #242424;
    text-align: left;
    font: var(
      --text-style-outlook-bodysmall,
      400 12px/16px "Segoe UI",
      sans-serif
    );
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    word-break: break-all;
  }

  .colleague-name {
    .icon-info {
      padding: 4px 0px 0px 2px !important;
    }
  }
`;

export const FloorPlanHeaderWrapper = styled.div<{ $theme?: string }>`
  display: flex;
  padding: 8px;
  justify-content: space-between;
`;

export const FloorPlanActionWrapper = styled.div<{ $theme?: string }>`
  display: flex;
  gap: 8px;
`;

export const FloorPlanNextAndPrevWrapper = styled.div<{ $theme?: string }>`
  display: flex;
  display: flex;
  align-items: center;
`;
export const RenderIconWrapper = styled.div<{ $theme?: string, $isDisable?: boolean }>`
  opacity: ${props => props.$isDisable ? 0.5 : 1};
  .floor-plan-arrow-left,
  .floor-plan-arrow-right {
    cursor: ${props => props.$isDisable ? "not-allowed" : "pointer"};
  }
`;

export const FloorPlanZoomWrapper = styled.div<{ $theme?: string }>`
  cursor: pointer;
`;

export const FloorPlanContentWrapper = styled.div<{
  $theme?: string;
  $maxHeight?: number;
}>`
  padding: 8px;
  height: 100%;
  .floor-header{
    max-height: ${(props) =>
    props.$maxHeight ? `${props.$maxHeight}px` : "100%"};
  overflow: auto;
  }

`;
